import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface DialogAction {
  text: string;
  result: boolean;
  color: string;
}

export interface DialogData {
    title: string;
    message: string;
    actions: DialogAction[];
  }

export const createDefaultData = (message: string): DialogData => {
  return {
    title: null,
    message,
    actions: [
      { text: "No", result: false, color: null },
      { text: "Yes", result: true, color: "#4499CC" }
    ]
  }
}

@Component({
    selector: 'confirm-dialog-dialog',
    templateUrl: 'confirm-dialog-dialog.html',
    styleUrls: ['confirm-dialog.component.scss'],
    standalone: false
})
  export class ConfirmDialogComponentDialog {
    data: DialogData;

    constructor(private readonly activeModal: NgbActiveModal) {}

    close(result: boolean): void {
      this.activeModal.close(result);
    }
  }